import { useContext, useEffect } from 'react';
import { ShareContext, IShareContent } from './index';

function useConfigShare(content: IShareContent) {
  const { configShare } = useContext(ShareContext);

  useEffect(() => {
    setTimeout(() => {
      configShare(content);
    });
  }, [content, configShare]);

  return {
    configShare,
  };
}

function useConfigShareReady() {
  const { ready } = useContext(ShareContext);

  return {
    ready,
  };
}

interface ShareContent {
  shareTitle?: string;
  shareDetail?: string;
  shareImg?: string;
}
interface PageContentData {
  shareContent: ShareContent;
  [key: string]: any;
}
function genShareConfig(pageContentData: PageContentData) {
  const { shareContent } = pageContentData || {};
  const { shareTitle, shareDetail, shareImg } = shareContent || {};
  const shareConfig: Record<string, string> = {};
  if (shareTitle) shareConfig.title = shareTitle;
  if (shareDetail) shareConfig.desc = shareDetail;
  if (shareImg) shareConfig.image = shareImg;
  return { shareConfig };
}

export { useConfigShare, useConfigShareReady, genShareConfig };
